import { render } from "./ButtonUi.vue?vue&type=template&id=de7d72dc&ts=true"
import script from "./ButtonUi.vue?vue&type=script&lang=ts"
export * from "./ButtonUi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__